import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';

@Pipe({
    name: "indDateFormat"
})
export class IndDateFormatPipe implements PipeTransform{
    constructor(private readonly dateTimeFormatsService: DateTimeFormatsService) {}

    transform(value: any, formatting?: string): string {
      let formatedDate;
      if(formatting){
        formatedDate = this.dateTimeFormatsService.isValidDate(new Date(value)) ? this.dateTimeFormatsService.formatDate(value, formatting) : '';
      }
      else {
        formatedDate = this.dateTimeFormatsService.isValidDate(new Date(value)) ? this.dateTimeFormatsService.formatDate(value,"MMM DD, YYYY") : '';
      }
      return formatedDate;
    }

}
